import { Box } from '@twilio-paste/core/box';
import { FormSection, FormSectionHeading } from '@twilio-paste/core/form';

import { ApiKeyType } from '../../../../modules/Apps';

import { RegenerateAppSecret } from './RegenerateAppSecret';

interface RegenerateAppSecretsSectionProps {
  appId: string;
}

export function RegenerateAppSecretsSection({ appId }: RegenerateAppSecretsSectionProps) {
  return (
    <FormSection>
      <FormSectionHeading>App Secrets</FormSectionHeading>
      <Box marginTop="space40">
        <RegenerateAppSecret
          apiKeyType={ApiKeyType.PrimaryKey}
          label="Primary API Key"
          infoText="Regenerate and rotate your primary API key"
          appId={appId}
        />
        <RegenerateAppSecret
          apiKeyType={ApiKeyType.SecondaryKey}
          label="Secondary API Key"
          infoText="Regenerate and rotate your secondary API key"
          appId={appId}
        />
      </Box>
    </FormSection>
  );
}
